import { render, staticRenderFns } from "./OrganizationRoamingConfig.vue?vue&type=template&id=7ad7759a"
import script from "./OrganizationRoamingConfig.vue?vue&type=script&lang=js"
export * from "./OrganizationRoamingConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports